/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiInsertionTypeFromJSON, ApiInsertionTypeToJSON, } from './ApiInsertionType';
import { ApiSimpleCampaignFromJSON, ApiSimpleCampaignToJSON, } from './ApiSimpleCampaign';
import { ApiSimpleComponentFromJSON, ApiSimpleComponentToJSON, } from './ApiSimpleComponent';
import { ApiSimpleLocationFromJSON, ApiSimpleLocationToJSON, } from './ApiSimpleLocation';
import { ApiSimpleProjectFromJSON, ApiSimpleProjectToJSON, } from './ApiSimpleProject';
import { ApiSimpleUserFromJSON, ApiSimpleUserToJSON, } from './ApiSimpleUser';
export function ApiSimplePersonalisationFromJSON(json) {
    return ApiSimplePersonalisationFromJSONTyped(json, false);
}
export function ApiSimplePersonalisationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'appliedTo': !exists(json, 'appliedTo') ? undefined : json['appliedTo'],
        'campaign': !exists(json, 'campaign') ? undefined : ApiSimpleCampaignFromJSON(json['campaign']),
        'campaignId': !exists(json, 'campaignId') ? undefined : json['campaignId'],
        'component': !exists(json, 'component') ? undefined : ApiSimpleComponentFromJSON(json['component']),
        'componentId': !exists(json, 'componentId') ? undefined : json['componentId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'insertionType': !exists(json, 'insertionType') ? undefined : ApiInsertionTypeFromJSON(json['insertionType']),
        'lastUser': !exists(json, 'lastUser') ? undefined : ApiSimpleUserFromJSON(json['lastUser']),
        'location': !exists(json, 'location') ? undefined : ApiSimpleLocationFromJSON(json['location']),
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'owner': !exists(json, 'owner') ? undefined : ApiSimpleUserFromJSON(json['owner']),
        'pending': !exists(json, 'pending') ? undefined : json['pending'],
        'project': !exists(json, 'project') ? undefined : ApiSimpleProjectFromJSON(json['project']),
    };
}
export function ApiSimplePersonalisationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'appliedTo': value.appliedTo,
        'campaign': ApiSimpleCampaignToJSON(value.campaign),
        'campaignId': value.campaignId,
        'component': ApiSimpleComponentToJSON(value.component),
        'componentId': value.componentId,
        'description': value.description,
        'id': value.id,
        'insertionType': ApiInsertionTypeToJSON(value.insertionType),
        'lastUser': ApiSimpleUserToJSON(value.lastUser),
        'location': ApiSimpleLocationToJSON(value.location),
        'locationId': value.locationId,
        'name': value.name,
        'owner': ApiSimpleUserToJSON(value.owner),
        'pending': value.pending,
        'project': ApiSimpleProjectToJSON(value.project),
    };
}
